import {AssetCategoryType} from '../../const';

export type AssetCategoryTypeSelectionValue = AssetCategoryType | null;
